import { useQuery, type QueryClient } from '@tanstack/react-query';
import {
  StatusCode,
  getPlanServiceCustomerPlan,
  getPlanServiceCustomerPlanPath,
  type PlanServiceCustomerPlanParams,
} from '@hungryroot/rest';

const TIME_LIMIT_15_MINUTES = 15 * 60 * 1000;

const getPlanServiceCustomerPlanQueryKey = ({
  is_staged,
}: PlanServiceCustomerPlanParams) => [
  'Customers',
  getPlanServiceCustomerPlanPath({ is_staged }),
];

export function usePlanServiceCustomerPlansView(
  { is_staged }: PlanServiceCustomerPlanParams,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: getPlanServiceCustomerPlanQueryKey({ is_staged }),
    queryFn: async () => {
      const resp = await getPlanServiceCustomerPlan({ is_staged });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: TIME_LIMIT_15_MINUTES,
    staleTime: TIME_LIMIT_15_MINUTES,
  });
}

export function invalidatePlanServiceCustomerPlansView(
  client: QueryClient,
  params: PlanServiceCustomerPlanParams
) {
  client.invalidateQueries({
    queryKey: getPlanServiceCustomerPlanQueryKey(params),
  });
}
